/**
 * Custom Ability class for role-based access control.
 * Replaces @casl/ability with a lightweight implementation.
 */
export class Ability {
  constructor(rules = []) {
    this._rules = rules
  }

  /**
   * Read-only access to current rules
   */
  get rules() {
    return this._rules
  }

  /**
   * Check if an action is allowed on a subject
   * @param {string} action - Action to check (e.g., 'read', 'create')
   * @param {string} subject - Subject/resource to check (e.g., 'User', 'Product')
   * @returns {boolean} true if action is allowed
   */
  can(action, subject) {
    // Handle null/undefined inputs
    if (!action || !subject) {
      return false
    }

    // Check if any rule matches the action and subject
    return this._rules.some(rule => {
      const hasAction = rule.actions.includes(action)
      const hasSubject = rule.subject.includes(subject) || rule.subject.includes('all')
      return hasAction && hasSubject
    })
  }

  /**
   * Update rules at runtime
   * @param {Array} newRules - New rules array to replace current rules
   */
  update(newRules) {
    this._rules = newRules
  }
}
